/* eslint-disable sonarjs/cognitive-complexity */
import { Router } from "@frui.ts/screens";
import type ConductorOneChildActive from "@frui.ts/screens/dist/structure/conductorOneChildActive";
import type ScreenBase from "@frui.ts/screens/dist/structure/screenBase";
import { View } from "@frui.ts/views";
import { observer, Observer } from "mobx-react-lite";
import React from "react";
import classNames from "classnames";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import Tooltip from "@edaz/edazkit/Tooltip";

export interface TabsProps {
  vm: ConductorOneChildActive<ScreenBase>;
  variant?: "light" | "white";
  children?: React.ReactNode;
  itemsCount?: number;
  totalCountMessages?: number;
  totalCountExemptions?: number;
  totalCountCharges?: number;
  totalCountVehicleRegister?: number;
  totalCountCardGateways?: number;
  totalCountBankTransfers?: number;
  displayVehicleRegisterWarning?: boolean;
  tooltipText?: string;
}

const Tabs = ({
  vm,
  children,
  variant = "light",
  itemsCount,
  totalCountMessages,
  totalCountExemptions,
  totalCountCharges,
  totalCountVehicleRegister,
  totalCountCardGateways,
  totalCountBankTransfers,
  displayVehicleRegisterWarning,
  tooltipText,
}: TabsProps) => {
  const getUrl = Router.getChildUrlFactory(vm);

  return (
    <>
      <div className="d-flex align-items-center">
        <nav className={classNames("nav", "nav-tabs", { "full-width": children === undefined })}>
          {vm.children.map((children, index) => (
            <a
              href={getUrl(children)}
              onClick={(e: any) => {
                e.preventDefault();
                vm.tryActivateChild(children);
              }}
              key={index}
              className={classNames("nav-item", "nav-link", "text-secondary", "d-flex", "align-items-center", {
                active: vm.activeChild === children,
                "bg-white": variant === "white",
              })}>
              <div>{children.name}</div>
              <div className="d-flex align-items-center pl-2" style={{ color: "#8E9398" }}>
                {vm.activeChild?.navigationName === children.navigationName && itemsCount && itemsCount > 0 ? itemsCount : null}

                {vm.activeChild?.navigationName !== children.navigationName &&
                children.navigationName === "emailMessage" &&
                totalCountMessages &&
                totalCountMessages > 0
                  ? totalCountMessages
                  : null}
                {vm.activeChild?.navigationName !== children.navigationName &&
                children.navigationName === "exemptions" &&
                totalCountExemptions &&
                totalCountExemptions > 0
                  ? totalCountExemptions
                  : null}
                {vm.activeChild?.navigationName !== children.navigationName &&
                children.navigationName === "charges" &&
                totalCountCharges &&
                totalCountCharges > 0
                  ? totalCountCharges
                  : null}
                {vm.activeChild?.navigationName !== children.navigationName &&
                children.navigationName === "vehicleRegisterVehicle" &&
                totalCountVehicleRegister &&
                totalCountVehicleRegister > 0
                  ? totalCountVehicleRegister
                  : null}
                {vm.activeChild?.navigationName !== children.navigationName &&
                children.navigationName === "card-gateway" &&
                totalCountCardGateways &&
                totalCountCardGateways > 0
                  ? totalCountCardGateways
                  : null}
                {vm.activeChild?.navigationName !== children.navigationName &&
                children.navigationName === "bank-transfer" &&
                totalCountBankTransfers &&
                totalCountBankTransfers > 0
                  ? totalCountBankTransfers
                  : null}
                {children.navigationName === "vehicleRegisterVehicle" && displayVehicleRegisterWarning && tooltipText ? (
                  <Tooltip
                    id="vehicle-register-vehicle-warning"
                    trigger={["hover", "focus"]}
                    tooltip={tooltipText}
                    placement="top">
                    <span>
                      <Icon icon={IconType.Error} width={24} height={24} />
                    </span>
                  </Tooltip>
                ) : null}
              </div>
            </a>
          ))}
        </nav>
        {children}
      </div>
      <div className="tab-content">
        <div className="mt-4 active fade show tab-pane">
          <Observer>{() => <View vm={vm.activeChild} />}</Observer>
        </div>
      </div>
    </>
  );
};

export default observer(Tabs);
